import { render, staticRenderFns } from "./GideLayout.vue?vue&type=template&id=051688c2&scoped=true"
import script from "./GideLayout.vue?vue&type=script&lang=js"
export * from "./GideLayout.vue?vue&type=script&lang=js"
import style0 from "./GideLayout.vue?vue&type=style&index=0&id=051688c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051688c2",
  null
  
)

export default component.exports